import Request from './request'
import store from '../store'
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';

async function fetch(data){
    return Request("get","api/economies/",data)
}

async function fetchOne(id,data){
    return Request("get","api/economies/" + id, data)
}

// 定价
async function confirm(id){
    return Request("post","api/economies/confirm/" + id)
}
// 作废
async function cancel(id){
    return Request("post","api/economies/cancel/" + id)
}

async function exportOne(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('post','api/economies/export?id=' + id)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop");
    return response
}



export default {
    fetch,
    fetchOne,
    confirm,
    cancel,
    exportOne
}